import theme from '@/theme';
import styled from '@emotion/styled';

export const Text = styled.h2`
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: -0.48px;
    color: ${theme.colors.secondary.main};
`;

export const MainText = styled.div`
    color: ${theme.colors.secondary.main};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.28px;
`;
